import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout: React.FC = () => (
  <div style={{ display: "flex", minHeight: "100vh", background: "var(--app-bg)" }}>
    <Sidebar />
    <main
      style={{
        marginLeft: 220,
        flex: 1,
        padding: 32,
        color: "var(--app-text)",
        minHeight: "100vh",
        overflowY: "auto",
      }}
    >
      <Outlet />
    </main>
  </div>
);

export default Layout;
